module.exports = __webpack_public_path__ + "assets/49e04c24c233cdf61ee4446cd97c4396.png";